import { QueryPageBase } from "./../queryPageBase";
//-查询参数
export class QueryForm extends QueryPageBase {
  groceryCnName: string = "";
  beginTime: string = "";
  endTime: string = "";
}
//查询结果数据格式
export class GetByPageData {
  tableData: GetByPageDataDetail[];
  total: number = 0;
}
//-查询结果数据格式-数据部分
export class GetByPageDataDetail {
  groceryEnName: string = "";
  groceryCnName: string = "";
  createTime: string = "";

  id: string = "";
}
// 获取stsToken参数
// export class GetStsParam {
//   ossType: number = 0; // 上传0 下载1
// }
// 上传文件到oss类
// export class UploadClass {
//   region: string = "oss-cn-beijing";
//   accessKeyId: string = "";
//   accessKeySecret: string = "";
//   bucket: string = process.env.Bucket;
//   stsToken: string = "";
// }
//-新增数据格式-数据部分
export class AddDataDetail {
  groceryEnName: string = "";
  groceryCnName: string = "";

  id: string = null;
}
